import { useLoadingStore } from '@/shared/lib/store/model/loading.store';
import * as RdxToast from '@radix-ui/react-toast';
import React from 'react';
import * as Portal from '@radix-ui/react-portal';

const Loading = () => {
    const { open, viewLoading } = useLoadingStore();
    return (
        <Portal.Root className="ttukttak">
            <RdxToast.Provider key={`laoding`} swipeDirection="right">
                <RdxToast.Viewport className="loading-viewport">
                    <RdxToast.Root open={open || viewLoading}>
                        <div
                            className="loading-backdrop"
                            onClick={(e) => e.stopPropagation()} // 클릭 이벤트 차단
                        >
                            <div className="loading" id="ajax-loading">
                                <div className="circle">
                                    <div className="c1">
                                        <span></span>
                                    </div>
                                    <div className="c2">
                                        <span></span>
                                    </div>
                                    <div className="c3">
                                        <span></span>
                                    </div>
                                    <div className="c4">
                                        <span></span>
                                    </div>
                                    <div className="c5">
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </RdxToast.Root>
                </RdxToast.Viewport>
            </RdxToast.Provider>
        </Portal.Root>
    );
};
export default Loading;
